export default "__VITE_ASSET__5be10966__"